import { InitialColorIds } from './initialColorIds'

export const initialColors = [
  {
    id: InitialColorIds.default,
    hexCode: '#2F7FEF',
    title: 'Blue',
    showInLegend: true,
  },
  {
    id: InitialColorIds.header,
    hexCode: '#18C4A9',
    title: 'Topaz',
    showInLegend: true,
  },
  {
    id: InitialColorIds.pear,
    hexCode: '#99CE43',
    title: 'Pear',
    showInLegend: false,
  },
  {
    id: InitialColorIds.tag2,
    hexCode: '#F8AB4B',
    title: 'Orange',
    showInLegend: false,
  },
  {
    id: InitialColorIds.tag1,
    hexCode: '#EA5E5E',
    title: 'Coral',
    showInLegend: false,
  },
  {
    id: InitialColorIds.magenta,
    hexCode: '#EB60BC',
    title: 'Magenta',
    showInLegend: false,
  },
  {
    id: InitialColorIds.footer,
    hexCode: '#AA5EEA',
    title: 'Purple',
    showInLegend: true,
  },
  {
    id: InitialColorIds.dusk,
    hexCode: '#768BA7',
    title: 'Dusk',
    showInLegend: false,
  },
  {
    id: InitialColorIds.cloudy,
    hexCode: '#ACBDD3',
    title: 'Cloudy',
    showInLegend: false,
  },
]
